import { TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS } from 'redux/actionTypes';

const initialState = [];

// export const locale[];

const PostPeContactListReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS:
			return [...action.data];
		default:
			return state;
	}
};

export default PostPeContactListReducer;
